export default __webpack_public_path__ + "static/media/Electrolyte-Software-Evaluation-License-Agreement.98650987.pdf";